import { render, staticRenderFns } from "./questions.vue?vue&type=template&id=c059ca0e&"
import script from "./questions.js?vue&type=script&lang=js&"
export * from "./questions.js?vue&type=script&lang=js&"
import style0 from "./questions.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports